module.exports = __webpack_public_path__ + "static/media/linkCopy.66d2ca7f.svg";